module.exports = __webpack_public_path__ + "static/img/wms.668d1798.svg";